import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { FileText, BarChart3, Settings2 } from 'lucide-react';
export function BankInterface() {
  const policyParams = [{
    param: 'Minimum score for any offer',
    setting: '40 / 100'
  }, {
    param: 'Maximum loan-to-monthly-GMV ratio',
    setting: '1.5× (Platinum cap)'
  }, {
    param: 'Sector exclusions',
    setting: 'Crypto, gambling, unregulated FX'
  }, {
    param: 'Maximum outstanding per merchant',
    setting: 'SGD 500,000'
  }, {
    param: 'Maximum portfolio concentration (single sector)',
    setting: '25% of total AUM'
  }, {
    param: 'Pricing model',
    setting: 'Factor rate · Simple interest · Amortizing P+I'
  }, {
    param: 'Minimum effective pricing (floor)',
    setting: 'Configurable per product (e.g. 1.10 factor / 8% APR)'
  }, {
    param: 'Re-scoring frequency for active loans',
    setting: 'Monthly'
  }];
  return <SectionWrapper title="Bank Interface: Reporting & Governance" subtitle="Since loans sit on the bank's balance sheet, the PSP operates as the technology and data layer only. The bank retains credit policy oversight." data-id="element-22">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-23">
        {/* Origination Pack */}
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-24">
          <div className="flex items-center gap-3 mb-6" data-id="element-25">
            <div className="p-2.5 rounded-lg bg-indigo-50 text-indigo-600" data-id="element-26">
              <FileText className="w-5 h-5" data-id="element-27" />
            </div>
            <h3 className="text-lg font-semibold text-slate-900" data-id="element-28">
              Origination Pack (Per Loan)
            </h3>
          </div>
          <ul className="space-y-3" data-id="element-29">
            {['Merchant score (total and per-factor breakdown)', '12-month GMV history with seasonality annotation', 'Eligibility confirmation against each hard gate', 'Loan structure: amount, pricing model (factor / interest / amortizing), holdback rate, target duration', 'Projected repayment schedule (monthly expected paydown)', 'Sensitivity analysis: repayment trajectory if GMV drops 20% or 40%', 'Bank credit policy compliance sign-off'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-slate-600" data-id="element-30">
                <div className="w-1.5 h-1.5 rounded-full bg-indigo-300 mt-2 flex-shrink-0" data-id="element-31" />
                <span className="leading-relaxed" data-id="element-32">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Monthly Portfolio Report */}
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-33">
          <div className="flex items-center gap-3 mb-6" data-id="element-34">
            <div className="p-2.5 rounded-lg bg-teal-50 text-teal-600" data-id="element-35">
              <BarChart3 className="w-5 h-5" data-id="element-36" />
            </div>
            <h3 className="text-lg font-semibold text-slate-900" data-id="element-37">
              Monthly Portfolio Report
            </h3>
          </div>
          <ul className="space-y-3" data-id="element-38">
            {['Outstanding balance per loan and aggregate portfolio balance', 'Repayment velocity vs projection — cohort and individual', 'Early warning flags active (by tier and count)', 'GMV trend per active borrower (with 30-day change)', 'Chargeback and refund rates across borrowing portfolio', 'Default and delinquency rates by origination cohort', 'Top-up originations in the period'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-slate-600" data-id="element-39">
                <div className="w-1.5 h-1.5 rounded-full bg-teal-300 mt-2 flex-shrink-0" data-id="element-40" />
                <span className="leading-relaxed" data-id="element-41">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>

      {/* Policy Parameters */}
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-42">
        <div className="px-6 py-4 border-b border-slate-200 bg-slate-50 flex items-center gap-2" data-id="element-43">
          <Settings2 className="w-5 h-5 text-slate-600" data-id="element-44" />
          <h3 className="font-semibold text-slate-900" data-id="element-45">
            Bank Credit Policy Parameters (Engine-Enforced)
          </h3>
        </div>
        <div className="overflow-x-auto" data-id="element-46">
          <table className="w-full text-sm text-left" data-id="element-47">
            <thead className="bg-slate-50/50 text-slate-500 font-medium border-b border-slate-100" data-id="element-48">
              <tr data-id="element-49">
                <th className="px-6 py-4" data-id="element-50">Policy Parameter</th>
                <th className="px-6 py-4" data-id="element-51">Example Setting</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-52">
              {policyParams.map((row, i) => <tr key={i} className="hover:bg-slate-50" data-id="element-53">
                  <td className="px-6 py-4 font-medium text-slate-800" data-id="element-54">
                    {row.param}
                  </td>
                  <td className="px-6 py-4 font-mono text-indigo-600 bg-indigo-50/30" data-id="element-55">
                    {row.setting}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </SectionWrapper>;
}